import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import "./Resource_Requirement.css";
import Personal_Report from "./inner_tab_reports/personal_report/Personal_Report";
import Training_Report from "./inner_tab_reports/training_report/Training_Report";
import Environmental_Report from "./inner_tab_reports/environmental_report/Environmental_Report";
import Intermediate_Check_Report from "./inner_tab_reports/intermediate_check_report/Intermediate_Check_Report";
import Instrument_Check_Report from "./inner_tab_reports/instrument_check_report/Instrument_Check_Report";
import E_P_P_S from "./e_p_p_s/E_P_P_S";

const Resource_Requirement = () => {
  const [show, setShow] = useState(false);

  const tabs = [
    "Personal  Report",
    "Training Report",
    "Environmental Report",
    "Intermediate Check Report",
    "Instrument Check Report",
    "Externally provided product & services",
  ];

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Resource Requirement" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container id="left-tabs-example" defaultActiveKey={tabs[0]}>
          <Nav variant="pills" className="">
            {tabs?.map((item) => {
              return (
                <Nav.Item>
                  <Nav.Link eventKey={item}>{item}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Personal  Report">
              <Personal_Report />
            </Tab.Pane>
            <Tab.Pane eventKey="Training Report">
              <Training_Report />
            </Tab.Pane>
            <Tab.Pane eventKey="Environmental Report">
              <Environmental_Report />
            </Tab.Pane>
            <Tab.Pane eventKey="Intermediate Check Report">
              <Intermediate_Check_Report />
            </Tab.Pane>
            <Tab.Pane eventKey="Instrument Check Report">
              <Instrument_Check_Report />
            </Tab.Pane>
            <Tab.Pane eventKey="Externally provided product & services">
              <E_P_P_S />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

      
    </section>
  );
};

export default Resource_Requirement;
